import React, { useState, useEffect, useContext } from "react";
import { cloneDeep } from "lodash";
import { ToastContainer } from "react-toastify";
import { Card, CardBody, Container } from "reactstrap";

import API from "utils/API";
import { AppContext } from "context";
import ErrorBoundary from "components/ErrorBoundary";
import { onExport, getUpdatedFilterLatest } from "utils/helper";
import SearchContainer from "./components/SearchContainer";
import ClaimsManagerTable from "./components/ClaimsManagerTable";

let filters = [];

const ClaimManager = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalItem, setTotalItem] = useState(0);
  const [claimStatusList, setClaimStatus] = useState([]);
  const {
    states: { claimsManager },
    setStates,
  } = useContext(AppContext);
  const { search, coveredEntity, searchTerms } = claimsManager;
  const { tenantID } = coveredEntity;

  useEffect(() => {
    if (searchTerms.coveredEntityID) handleSearch(searchTerms);
    fetchClaimStatus();
  }, []);

  const fetchClaimList = async (filters) => {
    if (!tenantID) return null;
    setLoading(true);
    try {
      const result = await API.post(`/${tenantID}/Claim/All`, filters);
      setData(result.data.items);
      setTotalItem(result.data.totalRecords);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchClaimStatus = async () => {
    try {
      const result = await API.get("RCMConfig/TypeStatus/ClaimStatus", {
        hasDefaultURL: true,
      });
      if (result && result.status === 200) {
        setClaimStatus(result.data);
      }
    } catch (error) {}
  };

  const handleExport = async () => {
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Claim/ExportAll?access_token=${access_token}`;
    onExport(action, search);
  };

  const handleSearch = async (filter) => {
    const {
      pharmacyID,
      claimStatusID,
      patientID,
      rxNumber,
      coveredEntityID,
      providerNPI,
      startDate,
      endDate,
    } = filter;

    Object.keys(filter).map((key) => {
      const index = filters.findIndex(
        (item) => item.filterName === key && key != "dateofservice"
      );
      filters.splice(index, 1);
    });

    if (coveredEntityID) {
      filters = getUpdatedFilterLatest(
        "coveredEntityID",
        parseInt(coveredEntityID),
        filters
      );
    }
    // claimFilters = filters;
    if (claimStatusID) {
      filters = getUpdatedFilterLatest(
        "claimStatusID",
        parseInt(claimStatusID),
        filters
      );
    }
    if (pharmacyID) {
      filters = getUpdatedFilterLatest("pharmacyID", pharmacyID, filters);
    }
    if (patientID) {
      filters = getUpdatedFilterLatest("patientID", patientID, filters);
    }
    if (rxNumber) {
      filters = getUpdatedFilterLatest("rxNumber", rxNumber.trim(), filters);
    }
    if (providerNPI) {
      filters = getUpdatedFilterLatest("providerNPI", providerNPI, filters);
    }
    if (startDate) {
      filters = getUpdatedFilterLatest(
        "dateofservice",
        startDate,
        filters,
        "startDate"
      );
    }
    if (endDate) {
      filters = getUpdatedFilterLatest(
        "dateofservice",
        endDate,
        filters,
        "endDate"
      );
    }
    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    search.filters = filters;
    await fetchClaimList(search);
  };

  const refetch = () => {
    handleSearch(searchTerms);
  };

  const handlePageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      fetchClaimList(filter);
    } else {
      fetchClaimList(filter);
    }
    claimsManager.search = { ...claimsManager.search, ...filter };
    setStates("claimsManager", claimsManager);
  };

  const handleReset = () => {
    setData([]);
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    filterObj.filters = [...filterObj.filters, ...columnFilters];
    await fetchClaimList(filterObj);
  };

  return (
    <div>
      <Container fluid className="my-3">
        <Card className="border-0 shadow-top">
          <CardBody className="section-devider-border">
            <ErrorBoundary>
              <SearchContainer
                claimStatusList={claimStatusList}
                onReset={handleReset}
                onSearch={handleSearch}
              />
            </ErrorBoundary>
          </CardBody>
          <CardBody className="pt-0">
            <ErrorBoundary>
              <ClaimsManagerTable
                data={data}
                loading={loading}
                filters={search}
                totalSize={totalItem}
                coveredEntity={coveredEntity}
                onExport={handleExport}
                refetch={refetch}
                onPageChange={handlePageChange}
                onSearchColumnFilters={handleSearchColumnFilters}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default ClaimManager;
